import React from 'react';
// import { useStore } from 'react-redux';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Button from '@material-ui/core/Button';
import API from '../../../create/api';
import * as helper from '../../../../helper/index';
import { useParams, useHistory } from 'react-router-dom';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CommentIcon from '@mui/icons-material/Comment';
import Comment from './comment';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import moment from 'moment-timezone';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import { toastr } from 'react-redux-toastr';
import LoadingButton from '@mui/lab/LoadingButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const Item = styled(Paper)(({ theme }: any) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function BookParcel(props: any) {
  // const store = useStore();
  const history = useHistory();

  const { parcel_id } = props;
  const [load, setLoad]: any = React.useState(false);
  const { id: id_param }: any = useParams();
  const [id, setID]: any = React.useState(id_param ?? parcel_id);
  const [get_log, set_log]: any = React.useState([]);

  const [booking_date, set_booking_date]: any = React.useState(moment().tz('Asia/Dhaka').format('YYYY-MM-DD'));
  const [memoNo, setMemoNo]: any = React.useState(null);
  const [customerName, setCustomerName]: any = React.useState(null);
  const [phoneNumber, setPhoneNumber]: [string | null, any] = React.useState(null);
  const [address, setAddress]: any = React.useState(null);
  const [weight, setWeight]: any = React.useState(1);
  const [COD, setCOD]: any = React.useState(0);
  const [details, setDetails]: any = React.useState(null);
  const [get_parcel, set_parcel]: any = React.useState(null);
  const [get_loading, set_loading]: any = React.useState(false);

  function setParcelData(parcel: any) {
    const {
      id,
      parcel_logs,
      created_at,
      // area,
      memoNo,
      customerName,
      phoneNumber,
      // rider,
      merchant_COD: COD,
      address,
      details,
      // status,
      // company,
      // deliveryCharge,
      weight,
      booking_date,
    } = parcel;

    set_booking_date(booking_date);
    setWeight(weight);
    // company?.id && setCompany({ label: company?.name, value: company?.id });
    // setStatus({ label: status, value: status });
    set_parcel(parcel);
    setDetails(details);
    setAddress(address);
    setCOD(COD);
    // setDeliveryCharge(deliveryCharge);
    // rider?.id && setRider({ label: rider?.name, value: rider?.id });
    setPhoneNumber(phoneNumber);
    setCustomerName(customerName);
    setMemoNo(memoNo);
    // area?.id && setArea({ label: area.name, value: area.id });
    // log
    const created = {
      created_at,
      details: 'Created',
      type: 'created',
    };
    set_log([created, ...(parcel_logs ?? [])]);
    // log

    setID(id);
    setLoad(true);
  }

  React.useEffect(() => {
    if (id) {
      API.get(`${process.env.REACT_APP_API_SERVER}/parcels`, id)
        .then((parcel) => {
          setParcelData(parcel);
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        });
    } else {
      setLoad(true);
    }
  }, [id]);

  async function create() {
    set_loading(true);
    const data = {
      booking_date,
      memoNo,
      customerName,
      phoneNumber,
      address,
      weight,
      merchant_COD: COD,
      details,
    };
    if (data.booking_date < new Date()) {
      set_loading(false);
      toastr.warning('Invalid Date', 'Date must be today or future');
      return;
    }

    const url = `${process.env.REACT_APP_API_SERVER}/parcels`;
    if (id) {
      await API.update(url, id, data)
        .then((parcel) => {
          setParcelData(parcel);
          toastr.success('Updated', '');
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        })
        .finally(() => {
          set_loading(false);
        });
    } else {
      await API.create(url, data)
        .then((parcel: any) => {
          toastr.success('Created', '');
          history.push(`/dashboard/parcel/edit/${parcel.id}`);
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        })
        .finally(() => {
          set_loading(false);
        });
    }
  }

  function get_icon(type: string) {
    if (type === 'created') {
      return <AccessTimeIcon />;
    }

    if (type === 'comment') {
      return <CommentIcon />;
    }

    if (type === 'status') {
      return <DoubleArrowIcon />;
    }

    if (type === 'rider') {
      return <DirectionsBikeIcon />;
    }

    return <TimelineDot />;
  }

  function MobileNo(mobile_no: string | null): boolean {
    if (mobile_no === null) {
      return true;
    }
    if (typeof mobile_no === 'string') {
      mobile_no = mobile_no.trim();

      if (mobile_no.includes(',')) {
        return mobile_no
          .split(',')
          .every(
            (num, i) =>
              (num?.trim()?.length === 11 &&
                new RegExp('^01', 'g').test(num?.trim()) &&
                new RegExp(/^\d+$/, 'g').test(num?.trim())) ??
              num?.trim()?.length === 0,
          );
      } else if (
        mobile_no?.length === 0 ||
        (new RegExp('^01', 'g').test(mobile_no) && new RegExp(/^\d+$/, 'g').test(mobile_no) && mobile_no?.length === 11)
      ) {
        return true;
      }
    }
    return false;
  }
  const showItem = (item: any) => {
    if (typeof item === 'object') {
      if (item != null) {
        return Object.entries(item).map((singleItem) => {
          if (['created_at', 'updated_at', 'id'].includes(singleItem[0])) {
            return '';
          }
          return `${singleItem[1]}\n`;
        });
      }
    } else {
      return item;
    }
  };

  return (
    load && (
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Item>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                disablePast
                label="Booking Date"
                inputFormat="yyyy-MM-dd"
                onChange={(newValue: Date | null) => {
                  set_booking_date(newValue);
                }}
                value={booking_date}
                renderInput={(params) => <TextField variant="standard" fullWidth {...params} />}
              />
            </LocalizationProvider>
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              variant="standard"
              fullWidth
              label="Invoice*"
              onChange={(e) => {
                setMemoNo(e.target.value);
              }}
              value={memoNo}
              defaultValue={memoNo}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              variant="standard"
              fullWidth
              label="Customer Name*"
              onChange={(e) => {
                setCustomerName(e.target.value);
              }}
              value={customerName}
              defaultValue={customerName}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              error={!MobileNo(phoneNumber)}
              helperText={!MobileNo(phoneNumber) ? 'Invalid Number' : ''}
              variant="standard"
              fullWidth
              label="Mobile*"
              onChange={(e) => {
                setPhoneNumber(e.target.value);
              }}
              value={phoneNumber}
              defaultValue={phoneNumber}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              variant="standard"
              fullWidth
              label="Address*"
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              value={address}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              type="number"
              variant="standard"
              fullWidth
              label="Weight Kg*"
              defaultValue={weight}
              onChange={(e) => {
                setWeight(e.target.value);
              }}
              value={weight}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              variant="standard"
              fullWidth
              label="Merchant COD"
              defaultValue={0}
              onChange={(e) => {
                setCOD(e.target.value);
              }}
              value={COD}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={3}>
          <Item>
            <TextField
              variant="standard"
              fullWidth
              label="Details by Merchant"
              onChange={(e) => {
                setDetails(e.target.value);
              }}
              value={details}
            />
          </Item>
        </Grid>
        <Grid item xs={12} md={12}>
          {get_loading ? (
            <LoadingButton loading loadingPosition="start" variant="outlined">
              {id > 0 ? 'Updating..' : 'Saving..'}
            </LoadingButton>
          ) : (
            <Button variant="contained" color="primary" onClick={create}>
              {id > 0 ? 'Update' : 'Save'}
            </Button>
          )}
        </Grid>
        {id && (
          <Grid xs={12} md={7}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Item>
                  ID: <b>{id}</b>
                </Item>
              </Grid>
              <Grid item xs={12} md={4}>
                <Item>
                  Updated Date:
                  {get_parcel?.updated_at && moment(get_parcel.updated_at).format('DD-MMM-YYYY hh:mm a')}
                </Item>
              </Grid>
            </Grid>
          </Grid>
        )}
        {id && (
          <Grid xs={12} md={5}>
            <Grid item xs={12} md={12}>
              <Timeline>
                {get_log.map(
                  (
                    log: { created_at: string; details: string; type: string; diff: object; id: any },
                    index: number,
                  ) => {
                    return (
                      <TimelineItem key={index}>
                        <TimelineOppositeContent color="text.secondary">
                          {moment(log.created_at).format('DD-MMM-YYYY hh:mm a')}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          {get_icon(log.type)}
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ width: '100px' }}>
                          {log.type === 'diff' ? (
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>--</TableCell>
                                  <TableCell>old</TableCell>
                                  <TableCell>new</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {Object.entries(log.diff).map((item: any) => {
                                  return (
                                    <TableRow>
                                      <TableCell>{item[0]}</TableCell>
                                      <TableCell>{showItem(item[1]?.__old)}</TableCell>
                                      <TableCell>{showItem(item[1]?.__new)}</TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          ) : (
                            log.details ?? ''
                          )}
                        </TimelineContent>
                      </TimelineItem>
                    );
                  },
                )}
              </Timeline>
            </Grid>

            <Grid item xs={12} md={12}>
              <Comment
                parcel_id={id}
                reload_parcel={async () => {
                  await API.get(`${process.env.REACT_APP_API_SERVER}/parcels`, id)
                    .then((parcel) => {
                      setParcelData(parcel);
                    })
                    .catch((e) => {
                      helper.axiosErrorHandling(e);
                    });
                }}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    )
  );
}
